module.exports = __webpack_public_path__ + "static/img/5.eb97966.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/5.png
// module id = Vyv8
// module chunks = 0